import Vue from "vue";
import Router from "vue-router";
import store from "./store/MainStore";
import NProgress from "nprogress";

Vue.use(Router);

const router = new Router({
  routes: [
    {
      path: "/",
      redirect: { name: "adventures" }
    },
    {
      path: "/adventures",
      name: "adventures",
      component: () => import("@/views/AdventureList.vue"),
      props: true,
      beforeEnter: (to, from, next) => {
        if (store.getters.userAuthenticated) {
          store.dispatch("fetchAdventures").then(adventures => {
            to.params.adventures = adventures;
            next();
          });
        } else next("/profile");
      }
    },
    {
      path: "/adventure/create",
      name: "adventure-create",
      component: () => import("@/views/AdventureCreate.vue")
    },
    {
      path: "/adventure/:adventure",
      name: "adventure-show",
      component: () => import("@/components/AdventureCardFull.vue"),
      props: true
    },
    {
      path: "/blairs",
      name: "blairs",
      component: () => import("@/views/blairs.vue"),
      props: true,
      beforeEnter(to, from, next) {
        if (store.getters.userAuthenticated) {
          store.dispatch("fetchFamily").then(family => {
            to.params.family = family;
            next();
          });
        } else next("/profile");
      }
    },
    {
      path: "/photos",
      name: "photos",
      component: () => import("@/views/photos.vue"),
      props: true,
      beforeEnter(to, from, next) {
        if (store.getters.userAuthenticated) {
          store.dispatch("fetchAlbums").then(albums => {
            to.params.albums = albums;
            next();
          });
        } else next("/profile");
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import("@/views/profile.vue"),
      alias: "/user"
    },
    {
      path: "/404",
      name: "404",
      component: () => import("@/views/NotFound.vue")
    },
    {
      path: "*",
      redirect: { name: "404" }
    }
  ]
});

router.beforeEach((to, from, next) => {
  if (store.getters.userAuthenticated || to.name == "profile") {
    NProgress.start();
    next();
  } else next("/profile");
});

router.afterEach(() => {
  NProgress.done();
});

export default router;
